import { axiosInstance } from "../../Authentication/AxiosInterceptor";

export type LibraryGen3Client = {
  id: string;
  name: string;
  enabled: boolean;
};

export type LibraryGen3List = {
  totalCount: number;
  enabledCount: number;
  clients: LibraryGen3Client[];
};

export const getLibraryGen3Clients = async (params: {
  q?: string;
  page: number;
  pageSize: number;
}): Promise<LibraryGen3List> => {
  const response = await axiosInstance.get<LibraryGen3List>("LibraryGen3/Clients", { params });
  return response.data;
};

export const updateLibraryGen3 = async (body: {
  scope: "Single" | "All";
  clientId?: string;
  enabled: boolean;
}): Promise<void> => {
  await axiosInstance.post("UpdateLibraryGen3", body);
};
